import { FC } from 'react'
import { store } from 'store'

import { logisticApi } from 'redux/services/logistic'
import { LogisticShortObject } from 'redux/services/logistic/types'

import { AppButton } from 'components/AppButton'

interface Props {
  logisticCart: LogisticShortObject
}

export const AnketaCell: FC<Props> = props => {
  const { logisticCart } = props

  const [getLogisticCartForEdit, { isFetching }] =
    logisticApi.useLazyGetLogisticCartForEditQuery()

  const handleClickAnketa = async () => {
    try {
      const applicationForEdit = await getLogisticCartForEdit({
        id: logisticCart.id,
      }).unwrap()
      if (applicationForEdit.anketa_file) {
        window.open(
          applicationForEdit.anketa_file,
          '_blank',
          'noopener,noreferrer',
        )
      } else {
        throw new Error('anketa file does not exist')
      }
    } catch (error: any) {
      store.dialogStore.openErrorModal({
        title: 'Произошла ошибка',
        text: error?.data?.message || 'Не удалось загрузить анкету',
      })
    }
  }

  return (
    <AppButton
      size="small"
      variant="gray"
      onClick={handleClickAnketa}
      disabled={isFetching}
    >
      Анкета
    </AppButton>
  )
}
